import React from "react";
import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  CardActions,
  Button,
} from "@mui/material";
import { useLocation } from "react-router-dom";

const projects_desktop = [
  {
    title: "Pos System",
    description: "One Pos System for all",
    image: "/images/pos.png",
  },
  {
    title: "Pharmacy System",
    description: "One System Pharmacy POS for all",
    image: "/images/pharmacy.png",
  },
  {
    title: "Clinic System",
    description: "One System Clinic for all",
    image: "/images/clinic.png",
  },
];

const projects_web = [
  {
    title: "E-commerce App",
    description: "Multi Vendor E-commerce with Dasboard Admin, Seller and Customer",
    image: "/images/ecommerce.png",
  },
  {
    title: "Human Resource App",
    description: "Human Resource System for Manage Employee",
    image: "/images/hrs.png",
  },
  {
    title: "Legal App",
    description: "Legal System for Document Legal and Case",
    image: "/images/legal.png",
  },
];

const projects_mobile = [
  {
    title: "Ecommerce App",
    description: "E-commerce system app for customer and seller",
    image: "/images/ecommerce-mobile.png",
  },
];

export default function Projects() {
  // 1. Baca query param ?category=...
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const category = params.get("category"); // 'desktop' | 'web' | 'mobile' | null

  // 2. Mapping kategori → array data
  const allProjects = {
    desktop: projects_desktop,
    web: projects_web,
    mobile: projects_mobile,
  };

  // 3. Pilih array yang akan dirender
  const toRender =
    category && allProjects[category]
      ? allProjects[category]
      : [
          ...projects_desktop,
          ...projects_web,
          ...projects_mobile,
        ];

  // Judul dinamis sesuai kategori
  const title = category
    ? `${category.charAt(0).toUpperCase() + category.slice(1)} Projects`
    : "All Projects";

  return (
    <Box sx={{ mt: 4, px: 2 }}>
      <Typography variant="h4" gutterBottom>
        {title}
      </Typography>

      <Grid container spacing={4}>
        {toRender.map((project, idx) => (
          <Grid item xs={12} sm={6} md={4} key={idx}>
            <Card
              sx={{ height: "100%", display: "flex", flexDirection: "column" }}
            >
              <Box
                component="img"
                src={project.image}
                alt={project.title}
                sx={{ width: "100%", height: 180, objectFit: "cover" }}
              />
              <CardContent sx={{ flexGrow: 1 }}>
                <Typography variant="h6" gutterBottom>
                  {project.title}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {project.description}
                </Typography>
              </CardContent>
              <CardActions>
                <Button size="small" color="primary">
                  {/* View Details */}
                </Button>
              </CardActions>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
